/**
 * The checklist, as (contract field, the label the operator reads).
 *
 * ONE table, driving the form, the gate and the request body alike, so
 * a box cannot be shown and then left out of what is sent. It mirrors
 * `DOOR_OVERRIDE_ACKNOWLEDGEMENTS` in the backend contract field-for
 * -field; the api-server answers a missing or `false` box with a 422,
 * with no defaults anywhere, so the dialog's gate is not belt-and-braces
 * — an unticked box has no valid request to send.
 *
 * The labels are FIRST PERSON because that is what makes the audit
 * record a claim somebody made rather than a fact somebody assumed.
 */
export const DOOR_OVERRIDE_CHECKLIST: ReadonlyArray<{
  field: 'i_can_see_the_door' | 'the_door_is_fully_open' | 'i_will_keep_it_open_until_the_robot_has_passed';
  label: string;
}> = [
  { field: 'i_can_see_the_door', label: 'I can see the door right now' },
  { field: 'the_door_is_fully_open', label: 'The door is fully open — not ajar, not closing' },
  {
    field: 'i_will_keep_it_open_until_the_robot_has_passed',
    label: 'I will keep it open until the robot has passed through',
  },
];
